export enum WorkerProfileStatus {
  Creating,
  Editing,
  AddingUnion
};